import React from 'react'

export const FormIsDisabledContext = React.createContext<boolean>(false)
